/**
 * Used to target ads to % of users. We generate a random number between 0 and 100, and then round it to the nearest 5.
 * Then, we create an array of numbers from 100 to that number. Then in GAM we use adGroup key-val to target ads to
 * certain % of users. For example:
 * Ad visible for 50% of users will be visible for everyone with adGroup=100,95,90,85,80,75,70,65,60,55,50
 * Ad visible for 80% of users will be visible for everyone with adGroup=100,95,90,85,80
 */
export const createAdTargetingGroup = (): string => {
  const generatedGroup = Math.ceil((Math.random() % 20) * 20) * 5;
  const groups = Array.from(
    { length: 21 },
    (_, index) => 100 - index * 5,
  ).filter((group) => group >= generatedGroup && group > 0);
  return groups.toString();
};
